// Converte texto digitado no formato brasileiro (vírgula como separador
// decimal, ex.: "20,50") para `number`. Também aceita ponto (alguns
// teclados numéricos de dispositivo inserem "."), normalizando vírgula→
// ponto antes de converter — sem isso, `parseFloat("20,50")` para no
// primeiro caractere não numérico e silenciosamente vira `20`, truncando o
// valor digitado sem avisar a usuária (bug real de apps de precificação em
// pt-BR).
//
// Campo vazio conta como 0 (mesma convenção do "decidir depois": ausência
// de valor = 0, nunca `null`/`undefined` gravado em `hourly_rate`/
// `default_markup_pct`, que são `NOT NULL` no schema). Retorna `null`
// apenas para texto que não é um número válido, para a tela distinguir
// "vazio" (ok) de "usuária digitou algo que não dá pra usar" (mostrar
// erro).
export function parseLocaleNumber(text: string): number | null {
  const trimmed = text.trim();
  if (trimmed === '') {
    return 0;
  }

  const normalized = trimmed.replace(',', '.');
  const value = Number(normalized);
  return Number.isNaN(value) ? null : value;
}
